import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import InputGroup from '../../form/input-group';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { forum_name: null };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.forum_name != this.state.forum_name) {
            return true;
        }

        if (nextProps.forum_name && nextProps.submitted && nextProps.forumsHost) {
            document.location.href = nextProps.forumsHost;
        }

        if (nextProps.forum_name != this.props.forum_name) {
            return true;
        }

        if (nextProps.horumsHost != this.props.horumsHost) {
            return true;
        }

        if (nextProps.formError != this.props.formError) {
            return true;
        }

        if (nextProps.formErrors != this.props.formErrors) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        if (nextProps.submitted != this.props.submitted) {
            return true;
        }

        return false;
    }

    render() {
        const disabled = !this.state.forum_name || this.props.submitting;

        return (
            <forums-register>
                <form autoComplete='off' onSubmit={this.submit}>
                    <row className='is-wrap'>
                        <column className='is-12'>
                            <InputGroup
                                type='text'
                                name='forum_name'
                                value={this.state.forum_name}
                                error={this.props.formErrors.forum_name}
                                label='Your Forums Username'
                                onInput={this.setUsername}
                            />
                        </column>
                        <column className='is-12 has-text-center'>
                            <button
                                className={`button ${disabled ? 'disabled' : ''}`}
                                disabled={disabled}
                                onClick={this.submit}
                            >{this.props.submitting ? 'SUBMITTING...' :'SUBMIT'}</button>
                        </column>
                    </row>
                </form>
            </forums-register>
        );
    }

    setUsername = (e) => {
        this.setState({ forum_name: e.target.value });
    }

    submit = (e) => {
        e.preventDefault();

        this.props.checkUsername(this.state.forum_name);
    }
}

const mapStateToProps = (state) => ({
    forum_name: state.user && state.user.forum_name,
    forumsHost: state.forums && state.forums.host,
    formError: state.form && state.form.error,
    formErrors: state.form && state.form.errors,
    submitting: state.form && state.form.submitting,
    submitted: state.form && state.form.submitted,
});

const mapDispatchToProps = (dispatch) => ({
    checkUsername: (payload) => dispatch({ type: 'member:check-forums-username', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);